import { notification, Tabs } from "antd";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Star from "../assets/images/advisorStar.png";
import leftarrow from "../assets/images/u_angle-left-b.svg";
import greyCircle from "../assets/images/ellipse.svg";
import { apiServices } from "../services/Api";
import AdvisorMainContent from "../layout/AdvisorMain";
import AboutMe from "../components/Advisors/MyProfileTabs/AboutMe";
import AboutMySubscription from "../components/Advisors/MyProfileTabs/AboutMySubscription";
import MyRecentTrades from "../components/Advisors/MyProfileTabs/MyRecentTrades";

const AdvisorMyProfile = () => {
  const navigate = useNavigate();
  const [advisor, setAdvisor] = useState(null);

  const getAdvisor = async () => {
    try {
      const response = await apiServices.get(`advisors/me`);
      setAdvisor(response);
      return response;
    } catch (e) {
      notification.error({
        message: "Failed to get Advisor details",
      });
    }
  };

  useEffect(() => {
    getAdvisor();
  }, []);

  const advisorStats = {
    "Success rate": `%*`,
    Accuracy: `%*`,
    ROI: `%*`,
    Experience: `Years*`,
  };

  const items = [
    {
      key: "1",
      label: "About Advisor",
      children: <AboutMe advisor={advisor} />,
    },
    {
      key: "2",
      label: "About Subscription",
      children: <AboutMySubscription />,
    },
    // {
    //   key: "3",
    //   label: "Recent Trades",
    //   children: <MyRecentTrades />,
    // },
  ];

  return (
    <AdvisorMainContent>
      <div className="p-4 lg:p-6 flex flex-col gap-4 lg:gap-6  lg:mx-6 lg:my-6">
        <div className="bg-white rounded-lg p-4 lg:p-6 shadow-[0_2px_8px_rgba(0,0,0,0.1)]">
          <div className="flex flex-col lg:flex-row justify-between items-start gap-4 lg:gap-6">
            <div className="flex items-start gap-3 lg:gap-4 flex-1 w-full">
              <div
                className="flex items-center justify-center w-10 h-10 lg:w-12 lg:h-12 rounded-lg border border-[#D9D9D9] bg-white hover:bg-gray-50 transition-colors"
                onClick={() => {
                  navigate("/advisordashboard");
                }}
              >
                <img
                  src={leftarrow}
                  alt="left-arrow"
                  className="w-5 h-5 lg:w-6 lg:h-6"
                />
              </div>
              <div className="flex-grow flex flex-col gap-3">
                <div className="flex flex-col lg:flex-row lg:items-center gap-3 lg:gap-4 flex-wrap">
                  <span className="text-xl lg:text-2xl font-bold font-inter text-[#454545]">
                    {advisor?.firstName} {advisor?.lastName}
                  </span>

                  {/* <div className="flex gap-2 flex-wrap">
                    <div className="flex px-2 py-1.5 items-start gap-2.5 rounded-md bg-[#EFF8FF] text-[#1569AB] text-center text-sm font-medium">
                      <span>Futures*</span>
                    </div>
                    <div className="flex px-2 py-1.5 items-start gap-2.5 rounded-md bg-[#EFF8FF] text-[#1569AB] text-center text-sm font-medium">
                      <span>Stock Options*</span>
                    </div>
                  </div> */}
                </div>
                {/* <div className="flex gap-4 lg:gap-6 items-center flex-wrap">
                  <div className="flex items-center gap-1.5">
                    <img src={Star} width={16} height={16} alt="star" />
                    <span className="text-sm lg:text-base font-semibold text-primary">
                      4.3*
                    </span>
                  </div>
                  <div className="text-sm lg:text-base text-[#6B7280]">
                    Followers:{" "}
                    <span className="font-semibold text-[#333]">129*</span>
                  </div>
                </div> */}
              </div>
            </div>
            {/* <div className="w-full lg:w-auto">
              <button className="w-full lg:w-auto px-6 py-2.5 bg-primary text-white rounded-lg font-medium hover:bg-primary/90 transition-colors">
                Subscribe
              </button>
            </div> */}
          </div>

          <div className="border-t border-gray-200 my-4 lg:my-6" />

          <div className="flex flex-wrap gap-6 lg:gap-8">
            {Object.entries(advisorStats).map(([stat, value]) => (
              <div key={stat} className="flex gap-2 items-center">
                <img
                  src={greyCircle}
                  width={8}
                  height={8}
                  alt="bullet"
                  className="opacity-60"
                />
                <p className="text-sm lg:text-base">
                  <span className="font-normal text-[#7F7F7F] font-roboto">
                    {stat}:
                  </span>{" "}
                  <span className="font-semibold text-[#454545] font-roboto">
                    {value}
                  </span>
                </p>
              </div>
            ))}
          </div>
        </div>
        <div className="bg-white rounded-lg  shadow-[0_2px_8px_rgba(0,0,0,0.1)] p-4 lg:p-6">
          <Tabs defaultActiveKey="1" items={items} />
        </div>
      </div>
    </AdvisorMainContent>
  );
};

export default AdvisorMyProfile;
